export const portalZh = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "欢迎——我们能为您做些什么？",
    subtitle: "请告诉我们您的来意，以便我们为您提供合适的指引。",
    later: "我稍后再填写",
    back: "返回",
    choices: {
      applyTitle: "申请 Thailand Elite：Thailand Privilege 签证",
      applyDesc: "开始您的会员资格 / 长期签证申请。",
      memberTitle: "我已经是 Thailand Elite 会员",
      memberDesc: "关联您的会员资格或申请会员服务。",
      prospectTitle: "在决定之前我有一些问题",
      prospectDesc: "获取信息并与顾问交流。",
      partnerTitle: "我代表一家代理机构或合作伙伴",
      partnerDesc: "了解合作与推荐方案。",
      otherTitle: "其他事项",
      otherDesc: "其他类型的请求——告诉我们如何为您提供帮助。",
      servicesTitle: "房产、保险及其他服务",
      servicesDesc: "房产、保险、其他签证或在泰国安家协助。",
    },
    applicant: {
      heading: "几个简单的问题",
      subtitle: "这有助于我们为您定制申请。您可以稍后修改。",
      purposeLabel: "您选择 Thailand Elite 的主要原因是什么？",
      timelineLabel: "您计划何时申请或搬迁？",
      submit: "继续我的申请",
    },
    purpose: {
      retirement: "退休 / 长期居留",
      business: "商务 / 工作",
      family: "家庭 / 受抚养人",
      investment: "投资",
      lifestyle: "生活方式 / 频繁旅行",
      other: "其他",
    },
    timeline: {
      asap: "尽快",
      m1_3: "1–3 个月内",
      m3_6: "3–6 个月内",
      m6_12: "6–12 个月内",
      exploring: "只是先了解一下",
    },
    member: {
      heading: "欢迎回来——让我们找到您的会员资格",
      subtitle: "请提供您的会员编号，我们的团队将在快速核实后将其关联到此账户。",
      idLabel: "会员编号 / 卡号",
      idPlaceholder: "例如 TPC123456",
      sinceLabel: "您从何时成为会员？",
      sincePlaceholder: "例如 2022",
      viaLabel: "您是如何申请的？",
      viaPlaceholder: "代理、直接申请等",
      helpLabel: "我们能为您做些什么？",
      helpPlaceholder: "描述您的需求（签证贴签、90 天报到、续签……）。",
      submit: "提交",
    },
    inquiry: {
      heading: "请告诉我们更多信息",
      subtitle: "我们会将您的请求转交给合适的人员并跟进。",
      typeLabel: "您的请求与什么有关？",
      messageLabel: "您的留言",
      messagePlaceholder: "告诉我们如何为您提供帮助。",
      submit: "提交请求",
    },
    inquiryTypes: {
      general_inquiry: "一般咨询",
      member_service: "现有会员——服务请求",
      partnership: "代理 / 合作",
      visa_other: "其他签证 / 移民问题",
      other_services: "房产、保险或其他服务",
      other: "其他",
    },
    services: {
      heading: "我们可以为您提供哪些帮助？",
      subtitle: "请选择您感兴趣的所有内容——我们将为您对接合适的合作伙伴。",
      interestsLabel: "我感兴趣的是",
      messageLabel: "还有其他补充吗？",
      messagePlaceholder: "例如：想在曼谷买公寓、为两人购买医疗保险……",
      submit: "发送",
      needInterestTitle: "请至少选择一项",
      needInterestDesc: "告诉我们您感兴趣的内容。",
    },
    interests: {
      real_estate: "房地产",
      insurance: "医疗 / 旅行保险",
      other_visa: "其他签证",
      business_setup: "公司注册 / 创业",
      relocation: "安家协助（学校、银行等）",
      extraLabel: "在泰国还有其他我们可以帮忙的吗？",
    },
    deleteAccount: {
      link: "误创建了此账户？删除账户",
      title: "删除您的账户？",
      desc: "您的账户及填写的信息将被永久删除，且无法恢复。",
      confirm: "删除我的账户",
      cancel: "取消",
      doneTitle: "账户已删除",
      doneDesc: "您的账户已删除。欢迎随时回来。",
      failedTitle: "无法删除账户",
      notEligible: "此账户已有申请或会员资格。请给我们留言，我们会为您关闭账户。",
    },
    done: {
      title: "您的请求已提交",
      desc: "谢谢——我们的团队将进行审核并尽快与您联系。",
      cta: "前往我的仪表板",
    },
    optionalTag: "（选填）",
    memberOutcome: {
      linkedTitle: "会员资格已关联 ✓",
      linkedDesc: "欢迎回来——您的会员专区已就绪。",
      pendingTitle: "即将完成——请确认您的会员资格",
      pendingDesc: "我们已向您登记的邮箱（{{email}}）发送了确认信息。在您确认且我们团队审核通过后，您的会员资格将被关联。",
    },
    banner: {
      memberTitle: "谢谢——我们正在核实您的会员资格",
      memberDesc: "我们的团队将很快把您的会员编号关联到此账户。确认后您将收到通知。",
      prospectTitle: "感谢您的联系",
      prospectDesc: "顾问将就您所需的信息与您跟进。准备好申请了吗？您可以随时在下方开始。",
      partnerTitle: "感谢您对合作的关注",
      partnerDesc: "准备好与我们合作了吗？提交您的公司资料即可开始，或由我们的合作团队与您联系。",
      partnerCta: "成为合作伙伴",
      otherTitle: "我们已收到您的请求",
      otherDesc: "我们的团队将进行审核并尽快与您跟进。",
    },
    toast: {
      saveFailedTitle: "无法保存",
      saveFailedDesc: "请重试。",
      applicantOkTitle: "太好了——让我们开始吧",
      applicantOkDesc: "您现在可以开始申请了。",
      needMessageTitle: "请添加简短留言",
      needMessageDesc: "告诉我们如何为您提供帮助。",
    },
  },
  common: {
    saveAndContinue: "保存并继续",
    back: "返回",
    submit: "提交申请",
    submitting: "提交中…",
    saving: "保存中…",
    uploading: "上传中…",
    required: "必填",
    optional: "选填",
    yes: "是",
    no: "否",
    select: "请选择…",
    uploaded: "已上传",
    missing: "缺失",
    loading: "加载中…",
    download: "下载",
    upload: "上传",
    remove: "删除",
    retry: "重试",
    next: "下一步",
    close: "关闭",
    addDocuments: "添加文件",
    signOut: "退出登录",
    memberPortal: "会员门户",
    language: "语言",
    // Toast messages
    fileTooLarge: "文件太大",
    maxSizeAllowed: "最大{{size}}。",
    uploadFailed: "上传失败",
    invalidEmail: "邮箱格式无效",
  },

  dashboard: {
    nextMemberApp: "附属成员申请",
    addNextMember: "添加附属成员",
    nextMemberPromo: "促销：附属成员每人75万泰铢，截至2026年12月31日",
    myApplications: "我的申请",
    noApplications: "暂无申请",
    noApplicationsDesc: "立即创建您的第一份申请，开启泰国精英之旅。",
    createApplication: "创建申请",
    newApplication: "新建申请",
    resumeApplication: "继续申请",
    alreadyActiveTitle: "申请正在进行中",
    alreadyActiveDesc: "您已有一份正在进行的申请。请完成或取消后再新建申请。",
    package: "套餐",
    created: "创建时间",
    messages: "消息",
    newThread: "新建会话",
    newThreadSubject: "主题",
    newThreadBody: "消息",
    generalInquiry: "一般咨询",
    noMessages: "暂无消息",
    status: {
      open: "开放",
      waiting_reply: "等待回复",
      closed: "已关闭",
      draft: "草稿",
      submitted: "已提交",
      under_review: "审核中",
      background_check: "背景调查中",
      approved: "已批准",
      payment_pending: "待付款",
      payment_done: "等待激活",
      active: "已激活",
      cancelled: "已取消",
      rejected: "已拒绝",
    },
  },

  // ── Member Area ──────────────────────────────────────────────────────────
  membership: {
    card: {
      sectionTitle: "您的会员卡",
      tierLabel:    "会员资格",
      holderLabel:  "持卡人",
      numberLabel:  "卡号",
      validFrom:    "有效期自",
      validUntil:   "有效期至",
      printOrSave:  "打印或另存为 PDF",
    },
    documents: {
      lettersTitle:                "官方信函",
      welcomeLetter:               "欢迎信",
      welcomeLetterDesc:           "您的 Thailand Elite 官方欢迎信",
      welcomeLetterPending:        "将在激活确认后由您的代理上传",
      certificationLetter:        "认证信函",
      certificationLetterDesc:    "Thailand Privilege 官方认证文件",
      certificationLetterPending: "由 Thailand Privilege 签发后即可获取",
      pending:                    "待处理",
    },
  },

  // ── Member Services / Service Requests ───────────────────────────────────
  services: {
    tabLabel:           "服务",
    title:              "会员服务",
    intro:              "提交服务请求——签证贴签、90 天报到，或任何其他咨询。您的会员编号将自动附加。",
    chooseType:         "选择服务",
    noTypes:            "目前暂无可用的服务类型，请联系客服。",
    estimated:          "约 {{days}} 个工作日",
    history:            "您之前的请求",
    back:               "返回服务列表",
    requirementsTitle:  "您需要提供的内容",
    memberIdLabel:      "提交身份",
    subject:            "主题",
    messageLabel:       "描述您的请求",
    messagePlaceholder: "请补充任何有助于我们更快处理您请求的细节。",
    attachments:        "附件",
    addFile:            "点击上传（PDF / JPG / PNG，最大 10 MB）",
    send:               "发送请求",
    submittedTitle:     "请求已提交",
    submittedDesc:      "我们的会员服务团队将进行审核并通过消息回复。",
    submittedDescMcc:      "我们的团队将审核并通过消息回复您。如需更快处理，请在下方将准备好的邮件发送给 MCC。",
    mcc: {
      title: "直接联系 MCC",
      intro: "此服务由 Thailand Privilege 会员联络中心（MCC）预约。请用您自己的邮箱发送这封已准备好的英文邮件：我们会收到副本并为您跟进。",
      titleNext: "加快您的申请：发送邮件给 MCC",
      recommended: "推荐 · 处理更快",
      oneMinute: "只需一分钟：邮件已准备好，直接发送即可。",
      attachReminder: "为保护隐私，您的文件不会自动附上。请将以下文件附在邮件中：{{files}}",
      linksIncluded: "您的文件已以安全链接形式包含在邮件中（有效期至 {{date}}）。您也可以将其作为附件添加。",
      copyTip: "提示：使用“复制邮件”并粘贴到您的邮箱中，文件名会变成可点击的链接。",
      emailButton: "给 MCC 发邮件",
      gmailButton: "在 Gmail 中打开",
      callButton: "致电 MCC",
      copyButton: "复制邮件",
      copied: "邮件已复制。",
      preview: "查看邮件",
      hidePreview: "隐藏邮件",
      confirmEmailTitle: "您已将邮件发送给 MCC 了吗？",
      confirmPhoneTitle: "您联系上 MCC 了吗？",
      confirmHint: "MCC 通常会在几小时内答复。如有急事，请发送邮件并同时致电 {{phone}}。",
      yes: "是",
      notYet: "还没有",
      statusEmail: "您已于 {{date}} 给 MCC 发送邮件。",
      statusPhone: "您已于 {{date}} 致电 MCC。",
      copyReceived: "我们已收到您邮件的副本。",
      followupTitle: "您收到 MCC 的答复了吗？",
      answered: "是，已解决",
      needHelp: "没有，我需要帮助",
      thanks: "谢谢，已记录。",
      helpSent: "我们会处理：团队将替您跟进 MCC。",
      packageTitle: "您的会员：{{package}}",
      privilegePoints: "特权积分",
      privilegeBook: "2026 特权手册（PDF）",
      mccLine: "会员联络中心：{{email}} · {{phone}}",
      done: "完成",
    },
    details: {
      whereTitle: "您希望在哪里贴签？",
      airport: "在机场，入境时",
      airportHint: "抵达日期须至少在今天 7 天之后。请准备好机票。",
      chaeng: "在曼谷 Chaeng Watthana 移民局",
      chaengHint: "须为工作日，且至少在今天 5 个工作日之后。需提供 TM30 副本。",
      arrivalAirport: "抵达机场",
      flightNumber: "航班号",
      departureFrom: "出发地",
      departurePlaceholder: "例如 上海 PVG",
      arrivalDate: "抵达日期",
      arrivalTime: "抵达时间（当地）",
      ticket: "机票或行程单",
      ticketHint: "PDF 或照片。我们会核对是否与上方航班一致。",
      ticketChecking: "正在核对机票…",
      ticketMatch: "机票已核对：航班和日期一致。",
      ticketMismatch: "请检查您的机票：",
      ticketUnreadable: "无法自动读取机票，我们的团队会人工核对。",
      preferredDate: "首选日期",
      period: "时段",
      morning: "上午（9:00–12:00）",
      afternoon: "下午（13:00–16:00）",
      alternativeDate: "备选日期（可选）",
      tentative: "日期为暂定，最终由 Member Services 根据名额确认。",
      tm30: "TM30 副本（住址证明）",
      tm30Hint: "房东或酒店出具的 TM30 回执。",
      passportCopy: "护照复印件（照片页）",
      passportHint: "将贴签证的护照。如果您已换新护照，请上传新护照。",
      passportFromApplication: "来自您的申请",
      useApplicationPassport: "使用我申请时的护照",
      passportNewWarning: "这不是您申请时使用的护照。使用新护照时，移民局可能需要重新进行背景审查后才能贴签证，可能需要更多时间。如需其他材料，我们会通知您。",
      tm30Guide: "什么是 TM30？",
      upload: "上传",
      replace: "替换",
      bank: "银行",
      bankPlaceholder: "选择银行",
      city: "城市",
      branch: "分行（可选）",
      branchPlaceholder: "例如 Silom、Central World",
      bankHint: "最终由银行决定，银行可能要求补充材料。",
      ninetyTitle: "关于 90 天报到",
      ninetySummary: "TM47 表格用于在连续居留每 90 天时确认您的住址。离开泰国后重新计算。可在到期日前 15 天至到期后 7 天内办理；逾期罚款 2,000 泰铢。",
      readGuide: "阅读完整指南",
      messageOptional: "还有其他需要告诉我们的吗？",
      noMessage: "详见下方信息。",
      licenseType: "驾照类型",
      car: "汽车",
      motorcycle: "摩托车",
      both: "汽车和摩托车",
      office: "陆路交通厅办公室",
      chatuchak: "曼谷 Chatuchak",
      otherOffice: "其他办公室",
      otherOfficePlaceholder: "城市 / 办公室",
      homeLicense: "您本国有效的驾照",
      residenceCertificate: "居住证明",
      residenceCertificateHint: "由您的大使馆出具（或工作许可证）。",
      medicalCertificate: "体检证明",
      medicalCertificateHint: "泰国诊所出具，一个月内有效。也可在预约前办理。",
      drivingIntro: "在我们联络员陪同下，于陆路交通厅一天内办完。请携带贴有 Privilege 签证的护照。",
      drivingGuide: "驾照办理指南",
      epaService: "服务",
      epaArrival: "入境",
      epaDeparture: "出境",
      epaAirport: "机场",
      flightDate: "航班日期",
      flightTime: "航班时间（当地）",
      originCity: "出发城市",
      originCityPlaceholder: "例如 上海",
      passengers: "乘客人数",
      epaHint: "EPA 服务时间为 06:00–24:00。请至少在航班前 5 小时预约。",
      optional: "可选",
      docType: "文件类型",
      docTypes: {
        passport: "护照",
        visa_page: "签证页",
        photo: "照片",
        entry_stamp: "入境章",
        tm30: "TM30",
        flight_ticket: "机票",
        home_license: "本国驾照",
        residence_certificate: "居住证明",
        medical_certificate: "体检证明",
        other: "其他文件",
      },
      phone: "电话号码（供 MCC 联系）",
      phoneHint: "来自您的资料，可修改。",
      fromApplication: "从我的申请中添加",
      fromApplicationHint: "您在申请时已上传的文件，无需再次上传。",
      appDocs: {
        passport_photo: "护照照片页",
        passport_signature: "护照签名页",
        visa: "签证页",
        arrival_stamp: "入境章",
        profile_photo: "照片",
        marriage_certificate: "结婚证",
        birth_certificate: "出生证明",
      },
      errors: {
        licenseTypeRequired: "请选择驾照类型。",
        officeRequired: "请选择办公室。",
        homeLicenseRequired: "请上传本国驾照。",
        residenceCertificateRequired: "请上传居住证明。",
        epaServiceRequired: "请选择入境或出境。",
        flightDateRequired: "请输入航班日期。",
        flightDatePast: "航班日期已过。",
        flightTimeRequired: "请输入航班时间。",
        epaTooSoon: "EPA 须至少在航班前 5 小时预约。",
        originCityRequired: "请输入出发城市。",
        locationRequired: "请选择贴签地点。",
        airportRequired: "请选择抵达机场。",
        flightNumberInvalid: "请输入航班号，例如 TG931。",
        arrivalDateRequired: "请输入抵达日期。",
        arrivalTooSoon: "抵达日期须为 {{date}} 或之后（今天起 7 天）。",
        arrivalTimeRequired: "请输入抵达时间。",
        preferredDateRequired: "请选择首选日期。",
        weekend: "移民局周末不办公，请选择周一至周五。",
        appointmentTooSoon: "请选择 {{date}} 或之后（今天起 5 个工作日）。",
        periodRequired: "请选择上午或下午。",
        alternativeInvalid: "备选日期须为工作日，且在 {{date}} 或之后。",
        tm30Required: "请上传 TM30 副本。",
        passportRequired: "请附上您的护照复印件。",
        bankRequired: "请选择银行。",
        cityRequired: "请选择城市。",
      },
    },
  },

  wizard: {
    applicationSteps: "申请步骤",
    step: "步骤",
    of: "/",
    readOnlyBanner: "此申请已提交。如需修改，请联系客服。",
    readOnlySupportLink: "申请修改",
    backgroundCheckTitle: "申请审核中",
    backgroundCheckBody: "您的申请目前正由我们的团队及相关泰国主管部门审核。在此阶段，您的申请无法取消或修改。如有任何疑问，请联系我们的客服团队。",
    backgroundCheckExpected: "您大约可在以下时间收到批准函：",
    backgroundCheckNote: "* 此为基于通常 4–8 周处理周期的预计时间，并非保证。",
    backgroundCheckContact: "如有疑问，请联系我们的团队：",
    steps: {
      package: "套餐",
      passport: "护照",
      personalInfo: "个人信息",
      address: "地址",
      visa: "签证与入境",
      documents: "文件",
      review: "审核",
    },
    stepDescriptions: {
      package: "选择您的泰国精英会员套餐",
      passport: "上传并验证您的护照",
      personalInfo: "填写您的个人信息",
      address: "您的居住地址和联系方式",
      visa: "当前签证和入境状态",
      documents: "上传并签署所需文件",
      review: "审核并提交您的申请",
    },
  },

  // ── Next Member ──────────────────────────────────────────────────────────
  nextMember: {
    title: "附属成员申请",
    subtitle: "您正在以附属成员身份，基于现有核心会员资格进行申请。",
    badge: "附属成员",
    addButton: "添加附属成员",
    relationship: "与核心会员的关系",
    selectRelationship: "选择关系…",
    relationships: {
      spouse: "配偶",
      child: "子女",
      parent: "父母",
      adopted_child: "养子女",
      civil_union: "民事结合伴侣",
    },
    coreApplication: "核心申请",
    additionalFee: "附属成员费用",
    promoLabel: "促销价",
    regularFee: "原价",
    promoUntil: "有效期至2026年12月31日",
    perMember: "/人",
    existingNextMember: "附属成员申请",
  },

  package: {
    title: "选择套餐",
    subtitle: "选择最适合您的泰国精英会员计划。",
    selected: "已选择",
    selectPackage: "选择套餐",
    years: "年",
    perYear: "每年",
    includes: "包含",
    familyOption: "可添加家庭成员",
  },

  passport: {
    title: "护照验证",
    subtitle: "上传护照个人信息页以进行OCR验证。",
    uploadTitle: "上传护照照片",
    uploadDesc: "护照个人信息页的照片或扫描件（JPG、PNG、PDF — 最大10MB）",
    uploadHint: "点击上传或拍照",
    extractTitle: "提取护照数据",
    extractDesc: "点击以使用 AI 自动填写您的信息 — 需要几秒钟",
    retakePhoto: "重拍 / 重新上传",
    passportNumber: "护照号码",
    surname: "姓",
    givenName: "名",
    nationality: "国籍",
    dateOfBirth: "出生日期",
    sex: "性别",
    dateOfIssue: "签发日期",
    dateOfExpiry: "有效期至",
    placeOfBirth: "出生地",
    mrz: "机读区（MRZ）",
    extractedData: "提取数据",
    verifyAndContinue: "确认并继续",
    lowConfidenceWarning: "部分字段无法清晰识别，请在继续前核实。",
    expiryWarning: "申请时护照有效期须至少6个月以上。",
    expiryModalTitle: "护照有效期问题",
    expiryModalDesc: "您的护照有效期必须超过申请日期后1年。请在申请前续签护照。",
    expiryModalCta: "我明白了",
    // Scan requirements
    scanRequirements: "扫描要求",
    scanReqColor: "彩色扫描 — 不接受黑白",
    scanReqEdges: "四边完整可见",
    scanReqResolution: "高分辨率，文字清晰可读",
    scanReqFocus: "不模糊或失焦",
    gallery: "相册",
    scanning: "扫描中…",
    uploadDifferentFile: "上传其他文件",
    fileFormatHint: "JPG、PNG 或 PDF · 最大 10 MB",
    // Gender options
    male: "男",
    female: "女",
    // Placeholders
    cityOrTown: "城市",
    country: "国家",
    asShownOnPassport: "与护照上显示一致",
    ifApplicable: "如适用",
    // Toast messages
    passportUploaded: "护照已上传",
    passportUploadedDesc: "点击\"AI扫描预填\"以提取您的数据。",
    passportScanned: "护照扫描成功 ✓",
    passportScannedDesc: "请核实下方提取的数据。",
    qualityIssuesDetected: "检测到质量问题",
    scanUnavailable: "扫描不可用",
    scanUnavailableDesc: "请手动填写您的信息。",
    applicationAlreadyExists: "申请已存在",
    applicationAlreadyExistsDesc: "已有{{name}}的申请记录。请继续该申请或联系客服。",
    // OCR quality issues
    blurryImage: "图像模糊",
    reflectionDetected: "检测到反光/眩光",
    glareOnPassport: "护照上有眩光",
    imageCropped: "图像被裁剪 — 请重新扫描完整护照",
    bioPageComplete: "信息页完整",
    mrzReadable: "MRZ可读",
    // Signature section
    signaturePage: "签名页",
    signatureOptional: "可选",
    signaturePageRequired: "如果您的资料页（Bio Page）上没有签名，请上传护照中包含您手写签名的页面。",
    signatureDetectedOnBio: "已在信息页检测到您的签名。如果您的护照有单独的签名页，也可以上传。",
    signatureDetectedConfirm: "已在护照信息页检测到签名 ✓",
    signatureDetectedNote: "如果您的护照还有专门的签名页（常见于法国、意大利、德国护照），可在下方上传。",
    signatureNotCorrect: "不正确 — 此页无签名",
    noSignatureOnBioPage: "信息页未发现签名",
    noSignatureOnBioPageNote: "部分护照信息页不包含签名 — 请上传包含您签名的页面。以下国家护照需要上传：<strong>新加坡、菲律宾、马来西亚、印度尼西亚、瑞典、阿联酋、沙特阿拉伯、卡塔尔、科威特、巴林、阿曼</strong>，以及大多数儿童护照。",
    signaturePageUploaded: "签名页已上传",
    uploadSignaturePageOptional: "上传签名页（可选）",
    uploadSignaturePage: "上传签名页",
    replace: "替换",
    pdf: {
      label: "护照PDF",
      openPreview: "打开PDF预览",
      detectedNote: "检测到 PDF — 将直接从 PDF 中读取护照资料页。",
    },
    ocrCooldown: "请稍候几秒后再重试。",
  },

  personalInfo: {
    title: "个人信息",
    subtitle: "核实并完善您的个人资料和申请信息。",
    profilePhoto: {
      title: "证件照",
      desc: "近期清晰的正面照片（护照风格），用于会员卡。",
      uploadButton: "上传照片",
      changeButton: "更换照片",
      takePhoto: "拍照",
      saved: "已保存",
      photoSaved: "照片已保存 ✓",
      photoUploadFailed: "照片上传失败",
      removeBackgroundAi: "AI去除背景",
      removeBackgroundNote: "背景将替换为白色 — 下次上传时应用。",
    },
    identity: {
      sectionTitle: "身份信息",
      title: "称谓",
      givenName: "名",
      middleName: "中间名",
      surname: "姓",
      nameOnCard: "精英卡上的姓名",
      nameOnCardHint: "显示在会员卡上的姓名",
      dateOfBirth: "出生日期",
      gender: "性别",
      occupation: "职业",
      businessIndustry: "所属行业",
    },
    applicationDetails: {
      sectionTitle: "申请详情",
      sectionDesc: "已从护照扫描中预填。检测到护照数据时将自动覆盖。",
      fromPassport: "来自护照",
      nationality: "国籍",
      placeOfBirth: "出生地",
      countryOfBirth: "出生国",
    },
    nationalityCheck: {
      question: "您目前是否持有其他国籍或公民身份？",
      otherNationality: "其他国籍",
      passportsIntro: "请申报您持有的所有其他护照和国籍。这些信息将填写在申请表第2页的《多重护照及国籍声明》上，并由您签署。",
      passportHeading: "其他护照 {{n}}",
      passportNumber: "护照号码",
      issueDate: "签发日期",
      expiryDate: "有效期至",
      nameOnPassport: "此护照上的全名（如不同）",
      addPassport: "添加其他护照",
      passportRequired: "请填写您其他护照的国籍和护照号码。",
      requiredDocsTitle: "多重国籍申请人所需文件：",
      reqDoc1: "原国籍护照；如曾更改姓名，还需提供以前的护照。",
      reqDoc2: "放弃原国籍的官方文件（如适用）。",
      reqDoc3: "证明您的收入及会员费资金来源的文件。",
      reqDoc4: "过去6个月在泰国或海外的永久居住证明。",
      mismatchTitle: "出生国与您的国籍不同",
      mismatchIntro: "我们还注意到，您的出生国与您的公民身份所属国不同，而您表示目前仅持有一个国籍。",
      mismatchBody: "请注意，移民局对签证贴签有严格要求，并可能要求提供额外文件。如果您持有双重国籍，必须如实申报。如果您已放弃之前的国籍，请准备相关证明文件。",
      listTitle: "如适用，请提供：",
      doc1: "您第二本护照的清晰副本。",
      doc2: "公民身份证书或其他说明您如何取得现有公民身份的文件副本，并附简要说明。",
      doc3: "如您曾持有其他国籍并已放弃，请提供放弃国籍证明副本。",
      explanationLabel: "简要说明（可选）",
      explanationPlaceholder: "例如：出生于巴西，2010年入籍，2012年放弃巴西国籍。",
      uploadTitle: "证明文件",
      uploadDesc: "PDF、JPG 或 PNG — 每个文件最大 10 MB。",
    },
    contact: {
      phone: "电话",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "电子邮件",
      emailHint: "用于您的申请，可与登录邮箱不同。",
    },
    sharedProfile: "共享资料",
    fillAllRequiredFields: "请填写所有必填字段",
  },

  address: {
    title: "地址",
    subtitle: "您当前的居住地址。",
    currentAddress: "当前地址",
    street: "街道地址",
    streetHint: "OpenStreetMap自动补全",
    startTyping: "开始输入您的地址…",
    city: "城市",
    state: "省/州",
    country: "国家",
    postalCode: "邮政编码",
    thaiAddress: "泰国地址",
    haveThaiAddress: "我有泰国地址",
    accommodationType: "住宿类型",
    province: "府",
    district: "区",
    subDistrict: "小区",
    thaiTelephone: "泰国电话",
    thaiPhoneNote: "泰国电话号码（不含前导0）",
    validationError: "请填写街道、城市和国家",
  },

  visa: {
    title: "签证与入境状态",
    subtitle: "您当前的泰国签证和入境信息。",
    currentVisa: "当前泰国签证",
    hasThaiVisa: "您目前持有泰国签证吗？",
    visaType: "签证类型",
    visaExpiry: "签证到期日",
    uploadVisaPage: "签证页照片",
    uploadVisaBtn: "上传签证页",
    arrivalStamp: "入境章",
    hasArrivalStamp: "您目前持有入境章吗？",
    stampExpiry: "入境章到期日",
    uploadStampPage: "入境章页照片",
    uploadStampBtn: "上传入境章页",
    passportStatus: "护照状态",
    blankVisaPages: "护照内是否有3页以上空白签证页？",
    blankYes: "是 — 3页以上",
    blankNo: "否 — 3页或以下",
    overstayCount: "过去3年在泰国逾期居留次数",
    overstayNever: "0 — 从未逾期",
    otherVisaOption: "其他（请注明）",
    otherVisaLabel: "请注明您的签证",
    otherVisaPlaceholder: "简称，例如 Non-O、SMART-T",
    edVisa: {
      sectionTitle: "教育签证（ED）历史",
      sectionDesc: "泰国精英资格评估所需申报。",
      question: "您在过去5年内或当前护照中是否有教育签证（ED）记录？",
      warningTitle: "需要额外支持文件",
      warningDesc: "有教育签证记录的申请人需提交以下文件，缺少文件可能导致申请被拒。",
      doc1: "学校设立许可证（สช.2 / OBEC / OPEC）",
      doc2: "学校注册证（ร.2）",
      doc3: "学校出具的在读证明",
      doc4: "学术成绩单、成绩报告及出勤记录",
      doc5: "课堂活动照片",
      doc5Optional: "（可选 — 如暂无可稍后上传）",
      acknowledgementForm: "知情确认表",
      acknowledgementFormDesc: "请下载、填写后与支持文件一同上传",
      uploadTitle: "上传支持文件",
      uploadDesc: "PDF、JPG或PNG — 可上传多个文件，安全保存至您的申请。",
    },
  },

  visaReminder: {
    title: "重要提示 — 请保持有效签证",
    body: "如果您身在泰国，请始终保持有效签证。提交此申请不代表授予您任何延长居留或在泰国停留的许可。如果您当前身在泰国，请确保您的签证在整个申请过程中始终有效。",
  },

  documents: {
    title: "文件",
    subtitle: "下载、签署并上传您的申请表格。",
    applicationForm: {
      title: "申请表",
      desc: "下载预填申请表，电子签名后上传。",
      download: "下载预填PDF",
      signDigitally: "电子签名",
      signatureCapture: "捕获签名",
      signatureCaptureDesc: "请在下方书写您的签名",
      clear: "清除",
      save: "保存签名",
      appliedTo: "已应用至所有页面",
      uploadSigned: "上传已签署表格",
    },
    pdpaForm: {
      title: "PDPA同意书",
      desc: "个人数据保护法同意书。请下载、签署后上传。",
      download: "下载PDPA表格",
      signDigitally: "电子签名",
      uploadSigned: "上传已签署表格",
    },
    uploadStatus: "上传状态",
    viewDocument: "查看已上传文件",
    downloadDocument: "下载已签署PDF",
    signingComplete: "签名完成 — 请上传保存",
    remaining: "剩余",
    requiredDocuments: "所需文件",
    continueToReview: "继续审核",
    blankForm: "空白表格",
    blankAddendum: "空白促销附录",
    downloadLabel: "下载",
    reprefill: "重新填充",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "申请表已预填",
    applicationFormPrefilledDesc: "已下载！请签署每页后上传或电子签名。",
    prefillFailed: "预填失败",
    applicationFormSigned: "申请表已签署并保存 ✓",
    signingFailed: "签名失败",
    applicationFormUploaded: "申请表已上传 ✓",
    pdpaFormSigned: "PDPA同意书已签署并保存 ✓",
    pdpaFormUploaded: "PDPA同意书已上传 ✓",
    documentUploaded: "文件已上传 ✓",
    uploaded: "已上传 ✓",
    translationUploaded: "翻译件已上传 ✓",
    uploadTranslation: "上传翻译件",
    relationshipProof: {
      title: "关系证明文件",
      subtitle: "请上传证明您与核心会员关系的官方文件。",
      marriageCert: "结婚证",
      birthCert: "出生证明",
      adoptionCert: "收养证明",
      civilUnionCert: "民事伴侣证明",
      notInEnglish: "此文件非英文",
      certifiedTranslation: "经认证的英文翻译",
    },
    signatureCapture: {
      title: "电子签名（可选）",
      subtitle: "绘制或上传您的签名以应用于所有申请文件。",
      saved: "签名已保存",
      willBeApplied: "将应用于所有文件",
      confirm: "我理解并希望电子签名",
      disclaimer1: "申请人必须亲自签署所有页面。如果申请人未满20岁，法定代理人也必须签名。",
      disclaimer2: "所有签名必须与护照上的签名完全一致。",
      disclaimer3: "⚠️ 我们接受电子签名，但请注意在某些情况下，泰国特权卡可能要求提供完整打印、手签并扫描的所有页面副本。如果您有打印机和扫描仪，我们强烈建议打印并手签。",
      options: {
        upload: {
          title: "上传签名",
          desc: "上传您签名的图片",
          instruction: "点击或拖拽图片文件到此处",
          enhancing: "优化中…",
          clickToUpload: "点击上传",
        },
        passport: {
          title: "使用护照签名",
          desc: "从已上传的护照扫描件中提取您的签名",
          passportRef: "护照扫描件",
          notFound: "未找到护照扫描件 — 请先上传护照",
          instruction: "点击从护照提取签名",
          uploadBtn: "从护照提取",
        },
        draw: {
          title: "绘制签名",
          desc: "使用鼠标或手指绘制您的签名",
        },
      },
    },
  },

  review: {
    title: "审核并提交",
    subtitle: "提交前请核实您的申请信息。",
    applicationSummary: "申请摘要",
    membershipPackage: "会员套餐",
    fullName: "全名",
    nationality: "国籍",
    dateOfBirth: "出生日期",
    passportNo: "护照号码",
    passportExpiry: "护照有效期",
    occupation: "职业",
    country: "国家",
    city: "城市",
    phone: "电话",
    email: "电子邮件",
    remaining: "剩余",
    requiredDocuments: "所需文件",
    passportPhoto: "护照/身份证照片",
    profilePhoto: "个人照片",
    applicationFormSigned: "申请表（已签署）",
    pdpaFormSigned: "PDPA同意书（已签署）",
    missingDocsWarning: "请在步骤6完成所有必要文件后再提交。",
    // Validation issues
    validation: {
      fullNameMissing: "缺少全名",
      passportNoMissing: "缺少护照号码",
      passportExpiryMissing: "缺少护照有效期",
      passportValidityWarning: "护照有效期必须超过申请日期后1年",
      nationalityMissing: "缺少国籍",
      otherNationalityMissing: "未回答关于其他国籍的问题",
      phoneMissing: "缺少电话号码",
      countryMissing: "缺少居住国家",
      cityMissing: "缺少城市",
      missingInfoTitle: "缺少信息 — 请在提交前完善",
      goTo: "前往",
      completeBeforeSubmitting: "请在提交前完善上述缺失信息",
      accountFlaggedTitle: "您的账户已被标记",
      uploadFlagged: "您上传的某个文件不符合我们的文件规定，因此您的账户已被标记待审核。如有误会，请给我们发送消息，我们的团队会进行核查。",
      contactUs: "给我们发消息",
      passportNotGenuine: "上传的文件不是可识读的护照资料页（带有您的照片和底部两行代码的页面）。请上传您真实护照的清晰副本。",
      passportDataMismatch: "部分信息与扫描的护照不一致：{{fields}}。请更正，使其与护照完全一致。",
      mismatchConfirm: "我的信息正确——请团队核查我的护照",
      fieldPassportNo: "护照号码",
      fieldDob: "出生日期",
      fieldExpiry: "护照有效期",
    },
    survey: {
      title: "问卷调查",
      howDidYouLearn: "您是如何了解到泰国精英的？",
      mainReason: "申请的主要原因是？",
      expectation: "您对会员资格有哪些期待？",
    },
    agreement: "本人确认所提供的所有信息真实、完整、准确。本人同意Dreamond及泰国特权卡有限公司（Thailand Privilege Card Co., Ltd.）处理本人的个人数据和文件——包括AI辅助护照OCR和签名验证——用于会员申请目的。本人了解在申请正式批准前无需付款，且任何付款须仅向泰国特权卡有限公司依据其官方发票支付。本人已阅读并同意",
    termsAndConditions: "服务条款",
    and: "及",
    privacyPolicy: "隐私政策",
    noPaymentNote: "申请正式批准前无需付款",
    missingDocumentsError: "文件不完整",
    missingDocumentsErrorDesc: "请在提交前上传所有必要文件。",
    submittedTitle: "申请已提交！",
    submittedDesc: "我们将审核您的申请并尽快与您联系。",
    submissionFailed: "提交失败",
  },

  // ── Post-Approval Screens ─────────────────────────────────────────────────
  screens: {
    common: {
      contactSupport: "如有疑问，请联系我们的团队：",
    },
    approved: {
      title: "恭喜！您的申请已获批准",
      message: "请查收您的电子邮件，获取批准函和发票。您必须在 30 天内完成付款以激活您的会员资格。",
      uploadTitle: "上传付款凭证",
      uploadHint: "银行转账回执、截图或 PDF（最大 10MB）",
      uploadButton: "上传付款凭证",
      uploadSuccess: "付款凭证已上传",
      uploadSuccessDesc: "财务部门通常会在约 3 个工作日内核实您的付款。",
      uploadedConfirmation: "付款凭证已上传——审核中",
      cardPaymentTitle: "使用信用卡付款",
      cardPaymentHint: "向财务部门申请安全付款链接",
      requestLink: "申请信用卡付款链接",
      payByCard: "使用信用卡付款",
      linkRequested: "请求已发送",
      linkRequestedDesc: "财务部门将尽快向您发送付款链接。",
      note: "如果您已上传付款凭证，则无需进一步操作。",
      proofRejectedTitle: "我们无法核实您的付款凭证",
      proofRejectedHelp: "请在下方上传新的付款凭证。如有疑问，请回复我们的邮件或联系我们。",
    },
    paymentPending: {
      title: "付款审核中",
      message: "我们已收到您的付款凭证，并已转交财务部门核实。核实通常需要约 3 个工作日，随后约需 4 个工作日激活会员资格并发出欢迎信。",
      verifying: "正在核实付款…",
      uploaded: "已上传",
      expected: "预计核实",
      uploadDate: "上传日期",
      expectedDate: "预计完成",
      activationDate: "预计激活",
      note: "以上为通常所需时间（合计约 7 个工作日），可能因款项到账时间和财务部门的工作量而有所不同。",
      verifiedTitle: "付款已核实",
      verifiedMessage: "您的付款已核实。您的会员资格正在办理中，欢迎信通常会在约 4 个工作日内发出。",
      addTitle: "添加其他付款文件",
      addHint: "如果财务部门要求补充材料，或您有银行对账单、扣款通知或 SWIFT MT103，请在此添加。所有文件将汇总用于核实。",
      addButton: "添加文件",
      added: "文件已添加",
      documentsTitle: "已发送的文件",
    },
    paymentDone: {
      title: "付款已确认",
      message: "您的付款已由财务部门确认。您将很快通过电子邮件收到欢迎信和会员卡信息。",
      verified: "付款已核实 ✓",
      nextStepsTitle: "接下来是什么？",
      step1: "您将通过电子邮件收到欢迎信",
      step2: "我们将为您准备会员卡",
      step3: "我们将就签证贴签预约与您联系",
      package: "您的会员资格",
    },
    prePayment: {
      title: "付款前重要须知",
      intro: "如您符合以下任一情形，请勿付款。",
      conditions: [
        {
          title: "入境章有效性",
          detail: "护照入境章所载停留许可须在有效期内。在本次停留期间存在逾期居留记录的申请人，在任何情况下均无法取得泰国精英（Thailand Privilege）签证。",
        },
        {
          title: "Non-Immigrant O 类（志愿者）签证",
          detail: "现持有或曾在任何时间持有 Non-Immigrant O 类（志愿者）签证的申请人，在任何情况下均无法取得泰国精英签证。",
        },
        {
          title: "Non-Immigrant MT 或 ED 签证",
          detail: "现持 Non-Immigrant MT（医疗）签证但未备妥医院出具的病患报告或医疗证明，或现持 Non-Immigrant ED（教育）签证但未备妥基础教育委员会办公室（OBEC）出具的官方文件及佐证材料的申请人，在任何情况下均无法取得泰国精英签证。",
        },
      ],
      warning: "如符合上述任一情形，Thailand Privilege Card Co., Ltd. 保留扣留会籍费用且不予退款的权利。",
      rulesTitle: "付款条件",
      rules: [
        { text: "依据《反洗钱法》B.E. 2542 (1999) 及其修正案，会籍费用须以单笔交易汇出。通过手机银行汇款亦须以单笔操作支付全额。" },
        { text: "Thailand Privilege Card Co., Ltd. 实际收到的金额须为会籍费用全额。所有银行手续费、中转行费用、代理费及其他境内外转账费用由您另行承担。" },
        { text: "批准函与发票自签发之日起 30 日内有效。逾期申请须重新进行背景审查。" },
        { text: "逾发票所载到期日付款者不予受理，并丧失任何优惠资格。" },
        { text: "本公司不接受美国运通（American Express）卡付款。" },
      ],
      doubt: "如不确定上述条件是否适用于您，请在付款前与我们联系，我们可先行审核您的材料。",
    },

    visaAffix: {
      title: "申请贴签",
      intro: "将申请发送给我们的团队：我们会附上您档案中已有的文件，转交会员服务中心（MCC），并跟进预约进度。",
      locationLabel: "希望办理贴签的地点",
      locations: {
        chaengWattana: "曼谷 Chaeng Wattana 移民局",
        suvarnabhumi: "素万那普机场，抵达时办理",
        phuket: "普吉国际机场，抵达时办理",
        chiangMai: "清迈国际机场，抵达时办理",
        overseas: "泰国境外（经泰国驻外机构申请电子签证）",
      },
      noticeThailand: "预约须提前 5 至 7 个工作日，并视 Elite Personal Liaison 的时间安排而定。",
      noticeOverseas: "电子签证经泰国政府官方门户签发，自递交之日起约需 15 至 30 个工作日。",
      dateLabel: "期望日期",
      flightLabel: "抵达航班",
      flightPlaceholder: "例如 TG911，10月14日",
      documentsLabel: "您档案中的文件",
      documentsHint: "请勾选需要我们附上的文件。默认全选。",
      documentTypes: {
        passport_photo: "护照",
        application_form: "申请表",
        consent_form: "同意书",
        payment_proof: "付款凭证",
      },
      submit: "撰写申请邮件",
      mccTitle: "会员服务中心（MCC）",
      mccHint: "如希望自行预约，可直接联系 MCC，并提供您的会员编号。",
      email: {
        subject: "贴签申请",
        intro: "本人希望申请 Privilege Entry 签证贴签预约。",
        member: "会员",
        card: "会员编号",
        package: "会籍",
        location: "希望办理地点",
        preferredDate: "期望日期",
        flight: "抵达航班",
        documentsHeld: "请从我的档案中附上",
        noneSelected: "未选择任何文件",
        notSpecified: "未指定",
        closing: "谢谢。",
      },
    },

    active: {
      title: "欢迎加入 Thailand Elite！",
      subtitle: "恭喜——您现已成为正式的 Thailand Elite 会员。",
      cardNo: "会员编号",
      package: "套餐",
      validFrom: "有效期自",
      validUntil: "有效期至",
      requestVisaAffix: "申请签证贴签",
      memberArea: "会员仪表板",
    },
    rejected: {
      title: "申请未获批准",
      titleCancelled: "申请已取消",
      message: "很遗憾，您的申请目前无法获得批准。如对此决定有任何疑问，请联系我们的客服团队。",
      messageCancelled: "此申请已取消。如果您希望再次申请，可以开始一份新的申请。",
      messageInactive: "此申请因长时间无操作已被关闭。您填写的所有内容均已保存——您可以从上次中断的地方继续。",
      resume: "继续我的申请",
      resumedToast: "欢迎回来！您的申请已重新开启。",
      resumeFailed: "无法重新开启此申请，请给我们发送消息。",
      info: "如果您希望再次申请，可以开始一份新的申请。",
      startNew: "开始新申请",
    },
  },

  auth: {
    login: {
      title: "会员门户",
      subtitle: "登录您的账户",
      email: "电子邮件",
      continueWithEmail: "使用电子邮件继续",
      sendingLink: "正在发送链接…",
      noPasswordNote: "我们将向您发送一个安全的登录链接 — 无需密码。",
      noAccount: "没有账户？",
      createOne: "创建一个",
      checkEmailTitle: "检查您的电子邮件",
      checkEmailDesc: "我们已将登录链接发送至 <strong>{{email}}</strong>。点击链接以访问您的账户。",
      didntReceive: "没有收到？",
      tryAgain: "再试一次",
      accountDisabledTitle: "账户已禁用",
      accountDisabledMsg: "您的账户已被禁用。",
      accountDisabledReason: "原因：",
      accountDisabledContact: "如果您认为这是一个错误，请联系我们：",
    },
    register: {
      title: "创建账户",
      subtitle: "开启您的泰国精英之旅",
      firstName: "名",
      lastName: "姓",
      email: "电子邮件",
      phoneNumber: "电话号码",
      searchCountry: "搜索国家…",
      continueWithEmail: "使用电子邮件继续",
      sendingLink: "正在发送魔术链接…",
      noPasswordNote: "我们将向您发送一个安全链接，用于验证您的电子邮件并登录 — 无需密码。",
      alreadyHaveAccount: "已有账户？",
      signIn: "登录",
      checkEmailTitle: "检查您的电子邮件",
      checkEmailDesc: "我们已将魔术链接发送至 <strong>{{email}}</strong>。点击电子邮件中的链接以登录并完成您的注册。",
      didntReceive: "没有收到？",
      tryAgain: "再试一次",
    },
  },
};
